/**
 * Created by lihanying on 2017/6/21.
 */
import React from 'react'
import './style.css'
import Routes from './routes'
import { Link } from 'react-router-dom'
import {
  CheckCircleOutlined,
  WindowsOutlined,
  BarChartOutlined,
  LineChartOutlined,
  UsergroupAddOutlined,
  LaptopOutlined,
  CreditCardOutlined,
  AppstoreOutlined,
  LayoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons'
import {
  Avatar,
  Breadcrumb,
  ConfigProvider,
  Dropdown,
  Layout,
  Menu,
  Tooltip,
} from 'antd'
import zh_CN from 'antd/lib/locale/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { CLUB_ID } from '../../ClubBusiness/constants'
import { fetchClubList } from '../action'
import { getClubCommodity } from '../../../api/permissionTemplate'
const { Header, Content, Footer, Sider } = Layout
const SubMenu = Menu.SubMenu
moment.locale('zh-cn')

class HomeView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openKeys: ['sub1'],
      collapsed: false,
      club_name: sessionStorage.getItem('club_name'),
      is_new_invoicing: sessionStorage.getItem('is_new_invoicing') || 0,
      club_testing: sessionStorage.getItem('club_testing') || 0,
      cid: '',
      showName: false,
    }
  }
  rootSubmenuKeys = [
    'sub0',
    'sub1',
    'sub2',
    'sub3',
    'sub4',
    'sub5',
    'sub6',
    'sub7',
    'sub8',
    'sub9',
    'sub12',
    'sub13',
    'sub14',
  ]

  componentDidMount() {
    // fetchClubList()
    this.setState(
      {
        cid: sessionStorage.getItem('club_id'),
      },
      () => {
        this.getClubInfo()
      }
    )
  }

  getClubInfo = () => {
    getClubCommodity().then((res) => {
      res.list &&
        res.list.map((item, index) => {
          if (item.id == this.state.cid) {
            this.setState({
              is_new_invoicing: item.is_new_invoicing,
              club_testing: item.testing,
            })
          }
        })
    })
  }

  onCollapse = (collapsed) => {
    this.setState({
      collapsed,
    })
  }
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  //退出时清除
  clearSession = () => {
    sessionStorage.removeItem('s')
    sessionStorage.removeItem('user_account')
    sessionStorage.removeItem('club_id')
    sessionStorage.removeItem('club_name')
    sessionStorage.removeItem('role_id')
  }

  //选择俱乐部
  onMenuItem = (item) => {
    console.log(item)
    const { clubList } = this.props
    sessionStorage.setItem('club_name', clubList[+item.key - 1].club_name)
    sessionStorage.setItem(CLUB_ID, clubList[+item.key - 1].id)
    sessionStorage.setItem('user_account', clubList[+item.key - 1].account)
    sessionStorage.setItem('role_id', clubList[+item.key - 1].role_id)
    sessionStorage.setItem(
      'is_new_invoicing',
      clubList[+item.key - 1].is_new_invoicing
    )
    sessionStorage.setItem(
      'club_testing',
      clubList[+item.key - 1].testing ? 1 : 0
    )
    this.setState({
      club_name: clubList[+item.key - 1].club_name,
      openKeys: ['sub1'],
      is_new_invoicing: clubList[+item.key - 1].is_new_invoicing,
      club_testing: clubList[+item.key - 1].testing,
    })
    this.forceUpdate()
    window.location.reload()
  }

  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(
      (key) => this.state.openKeys.indexOf(key) === -1
    )
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys })
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      })
    }
  }

  render() {
    const selectName = this.state.club_name
      ? this.state.club_name
      : sessionStorage.getItem('club_name')
    const { clubList } = this.props
    const userMenu = (
      <Menu style={{ width: '100px' }}>
        <Menu.Item key="1">
          用户: {sessionStorage.getItem('user_account')}
        </Menu.Item>
        <Menu.Item key="2">
          昵称: {sessionStorage.getItem('user_nickname')}
        </Menu.Item>
        <Menu.Item key="3" onClick={() => this.clearSession()}>
          <Link to="/">安全退出</Link>
        </Menu.Item>
      </Menu>
    )

    let purchaseData = []
    if (this.state.is_new_invoicing == 1) {
      purchaseData = [
        {
          idx: '7_1',
          link: '/home/purchaseSalesInventory/Merchandise',
          name: '商品列表',
        },
        {
          idx: '7_2',
          link: '/home/purchaseSalesInventory/Categories',
          name: '分类管理',
        },
        {
          idx: '7_3',
          link: '/home/purchaseSalesInventory/Stories',
          name: '仓库管理',
        },
        {
          idx: '7_4',
          link: '/home/purchaseSalesInventory/Statement',
          name: '库存流水',
        },
        {
          idx: '7_5',
          link: '/home/purchaseSalesInventory/ExpWarning',
          name: '临期商品',
        },
        {
          idx: '7_6',
          link: '/home/purchaseSalesInventory/StockWarning',
          name: '缺货提醒',
        },
      ]

      if (sessionStorage.getItem('club_id') <= 1005) {
        purchaseData.push({
          idx: '7_7',
          title: '旧商品管理',
          lists: [
            { idx: '7_7_1', link: '/home/ClubCommodity', name: '入库' },
            { idx: '7_7_2', link: '/home/ClubMarket', name: '销售' },
            { idx: '7_7_3', link: '/home/ClubRepertory', name: '库存' },
          ],
        })
      }
    } else {
      purchaseData = [
        { idx: '7_1', link: '/home/ClubCommodity', name: '入库' },
        { idx: '7_2', link: '/home/ClubMarket', name: '销售' },
        { idx: '7_3', link: '/home/ClubRepertory', name: '库存' },
      ]
    }

    const menuData = [
      {
        key: 'sub1',
        icon: () => <WindowsOutlined />,
        title: '首页',
        permission: '3',
        link: '/home/Homepage',
      },
      {
        key: 'sub2',
        icon: () => <UsergroupAddOutlined />,
        title: '管理员设置',
        permission: '1',
        items: [
          { idx: '2_1', link: '/home/ClubUsers', name: '电脑版管理员' },
          { idx: '2_2', link: '/home/ClubDeploy', name: '手机版管理员' },
        ],
      },
      {
        key: 'sub3',
        icon: () => <UsergroupAddOutlined />,
        title: '员工设置',
        permission: '1',
        // items: [{ idx: '3_1', link: '/home/ClubEmployee', name: '员工列表' }],
        items: [
            {
                idx: '3_1',
                link: '/home/ClubEmployeeManager',
                name: '员工列表',
            },
            {
                idx: '3_2',
                link: '/home/ClubShiftsSetting',
                name: '班次设置',
            },
            {
                idx: '3_3',
                link: '/home/ClubAttendanceRecord',
                name: '考勤记录',
            },
            {idx: '3_4', link: '/home/ClubServiceRecord', name: '服务记录'},
            {idx: '3_5', link: '/home/ClubCleanTableRecord', name: '打扫记录'},
            {idx: '3_6', link: '/home/ClubOperationLogs', name: '操作日志'},
            // {
            //   idx: '3_5',
            //   link: '/home/ClubSalaryStatistics',
            //   name: '薪酬统计',
            // },
            {idx: '3_7', link: '/home/ClubModuleManage', name: '模板管理'},
        ],
      },
      {
        key: 'sub4',
        icon: () => <BarChartOutlined />,
        title: '财务报表',
        permission: '2',
        items: [
          { idx: '4_1', link: '/home/Consume', name: '会员消费统计' },
          // {idx: '4_2', link: '/home/ClubRevenue', name: '旧营收报表'},
          { idx: '4_2', link: '/home/ClubRevenueNew', name: '营收报表' },
          { idx: '4_3', link: '/home/ClubShift', name: '交班报表' },
          { idx: '4_4', link: '/home/ClubBusiness', name: '收入明细报表' },
          { idx: '4_5', link: '/home/ClubExpend', name: '支出明细报表' },
          { idx: '4_8', link: '/home/ClubReserve', name: '预订明细报表' },
          { idx: '4_6', link: '/home/ClubStandby', name: '备用金明细报表' },
          { idx: '4_7', link: '/home/ClubStream', name: '钱包流水' },
          { idx: '4_9', link: '/home/TableUsageStatistics', name: '桌台使用时长统计' },
        ],
      },
      {
        key: 'sub5',
        icon: () => <LineChartOutlined />,
        title: '俱乐部会员',
        permission: '3',
        items: [
          { idx: '5_1', link: '/home/ClubMemberList', name: '会员列表' },
          { idx: '5_2', link: '/home/ClubBlacklist', name: '黑名单列表' },
          { idx: '5_3', link: '/home/ClubMember', name: '批量增加会员' },
          { idx: '5_4', link: '/home/ClubLevel', name: '等级列表' },
        ],
      },
      {
        key: 'sub6',
        icon: () => <LaptopOutlined />,
        title: '桌台管理',
        permission: '3',
        items: [
          { idx: '6_1', link: '/home/ClubTable', name: '桌台列表' },
          { idx: '6_2', link: '/home/ClubProfession', name: '分组列表' },
          // {idx: '6_3', link: '/home/ClubTableStatus', name: '实时经营'},
          { idx: '6_3', link: '/home/ClubDeletedTable', name: '已删除桌台' },
        ],
      },
      {
        key: 'sub13',
        icon: () => <LaptopOutlined />,
        title: '团购管理',
        permission: '3',
        items: [
          {idx: '13_1', link: '/home/GroupBuyingList', name: '团购列表'},
          {idx: '13_2', link: '/home/PlatformSetting', name: '团购平台设置'},
          {idx: '13_3', link: '/home/ClubPlatform', name: '团购关联授权'},
        ],
      },
      {
        key: 'sub7',
        icon: () => <CreditCardOutlined />,
        title: '卡券管理',
        permission: '3',
        link: '/home/CardManage',
      },
      // {
      //     key: 'sub8',
      //     icon: () => <LaptopOutlined />,
      //     title: '商品管理',
      //     permission: '3',
      //     items: [
      //         { idx: '8_1', link: '/home/ClubCommodity', name: '入库' },
      //         { idx: '8_2', link: '/home/ClubMarket', name: '销售' },
      //         { idx: '8_3', link: '/home/ClubRepertory', name: '库存' },
      //     ],
      // },
      {
        key: 'sub8',
        icon: () => <LaptopOutlined />,
        title: '商品管理',
        permission: '3',
        items: purchaseData,
      },
      {
        key: 'sub9',
        icon: () => <AppstoreOutlined />,
        title: '俱乐部设置',
        permission: '1',
        items: [
          { idx: '9_1', link: '/home/ClubWallet', name: '钱包设置' },
          { idx: '9_2', link: '/home/ClubInfo', name: '俱乐部信息设置' },
          {
            idx: '9_3',
            link: '/home/ClubCharge',
            name: '充值赠送及优惠设置',
          },
        ],
      },
      //  {
      //   key: 'sub10',
      //   icon: () => <TrademarkOutlined />,
      //   title: '计分板广告管理',
      //   permission: '3',
      //   link: '/home/advertManage',
      // },
      // {
      //   key: 'sub11',
      //   icon: () => <LayoutOutlined />,
      //   title: '结账广告管理',
      //   permission: '2',
      //   link: '/home/CheckOutAdvManage'
      // },
      {
        key: 'sub12',
        icon: () => <LayoutOutlined />,
        title: '工具下载',
        permission: '2',
        link: '/home/toolList',
      },
      {
        key: 'sub14',
        icon: () => <LaptopOutlined />,
        title: '小票打印机管理',
        permission: '2',
        link: '/home/ClubPrinterManage',
      },
      {
        key: 'sub15',
        icon: () => <LaptopOutlined />,
        title: '投诉记录',
        permission: '2',
        link: '/home/ClubComplaintManager',
      },
    ]
    //权限筛选
    const menu = menuData.filter(
      (item) => sessionStorage.getItem('role_id') <= item.permission
    )

    const isRechargeHelpPage =
      window.location.pathname == '/home/ClubChargeHelp'

    return (
      <div>
        {!isRechargeHelpPage && (
          <ConfigProvider locale={zh_CN}>
            <Layout style={{ height: '100%' }}>
              <Sider
                trigger={null}
                collapsible
                collapsed={this.state.collapsed}
                onCollapse={this.onCollapse}
                className="sideBar"
              >
                <Menu
                  theme="dark"
                  mode="inline"
                  openKeys={this.state.openKeys}
                  onOpenChange={this.onOpenChange}
                >
                  {clubList && clubList.length >= 2 ? (
                    <SubMenu
                      key="sup0"
                      title={
                        <span
                          onMouseOver={() => {
                            this.setState({
                              showName: true,
                            })
                          }}
                          onMouseLeave={() => {
                            this.setState({
                              showName: false,
                            })
                          }}
                        >
                          <CheckCircleOutlined />
                          <span className="nav-text">{selectName}</span>
                        </span>
                      }
                    >
                      {clubList.map((item, idx) => {
                        return (
                          <Menu.Item
                            key={idx + 1}
                            onClick={(item) => this.onMenuItem(item)}
                          >
                            {/* <Link to="/home/Homepage">{item.club_name}</Link> */}
                            <Tooltip placement="right" title={item.club_name}>
                              <Link to="/home/Homepage">{item.club_name}</Link>
                            </Tooltip>
                          </Menu.Item>
                        )
                      })}
                    </SubMenu>
                  ) : (
                    <Menu.Item key="0_1" style={{ marginBottom: '1rem' }}>
                      <span>
                        <CheckCircleOutlined />
                        <span className="nav-text">
                          {sessionStorage.getItem('club_name')}
                        </span>
                      </span>
                    </Menu.Item>
                  )}
                  {menu.map((item) => {
                    if (item.items) {
                      return (
                        <SubMenu
                          key={item.key}
                          icon={item.icon()}
                          title={item.title}
                        >
                          {item.items.map((list) => {
                            // return (
                            //   <Menu.Item key={list.idx}>
                            //     <Link
                            //       onClick={() => {
                            //         sessionStorage.setItem('reportName', list.name)
                            //       }}
                            //       to={list.link}
                            //     >
                            //       {list.name}
                            //     </Link>
                            //   </Menu.Item>
                            // )
                            if (list.lists) {
                              return (
                                <SubMenu
                                  key={list.idx}
                                  title={
                                    <span className="nav-text">
                                      {list.title}
                                    </span>
                                  }
                                >
                                  {list.lists.map((value) => (
                                    <Menu.Item key={value.idx}>
                                      <Link to={value.link}>{value.name}</Link>
                                    </Menu.Item>
                                  ))}
                                </SubMenu>
                              )
                            } else {
                              return (
                                <Menu.Item key={list.idx}>
                                  <Link
                                    onClick={() => {
                                      sessionStorage.setItem(
                                        'reportName',
                                        list.name
                                      )
                                    }}
                                    to={list.link}
                                  >
                                    {list.name}
                                  </Link>
                                </Menu.Item>
                              )
                            }
                          })}
                        </SubMenu>
                      )
                    } else {
                      return (
                        <Menu.Item key={item.key}>
                          <Link
                            to={item.link}
                            style={{ color: '#C0C0C0', textDecoration: 'none' }}
                          >
                            {item.icon()}
                            <span>{item.title}</span>
                          </Link>
                        </Menu.Item>
                      )
                    }
                  })}
                </Menu>
              </Sider>
              <Layout>
                <Header style={{ background: '#fff', padding: 0 }}>
                  {this.state.collapsed ? (
                    <MenuUnfoldOutlined
                      style={{ fontSize: '22px' }}
                      onClick={this.toggle}
                    />
                  ) : (
                    <MenuFoldOutlined
                      style={{ fontSize: '22px' }}
                      onClick={this.toggle}
                    />
                  )}
                  <Dropdown overlay={userMenu}>
                    <a
                      className="ant-dropdown-link"
                      href="#"
                      style={{ position: 'absolute', right: '1rem' }}
                    >
                      <Avatar src={sessionStorage.getItem('headimgurl')} />
                    </a>
                  </Dropdown>
                </Header>
                <Content style={{ margin: '0 16px', minHeight: 'auto' }}>
                  <Breadcrumb style={{ margin: '12px 0' }}>
                    {/*<Breadcrumb.Item>User</Breadcrumb.Item>*/}
                    {/*<Breadcrumb.Item>Bill</Breadcrumb.Item>*/}
                  </Breadcrumb>
                  <div
                    style={{
                      padding: 24,
                      background: '#fff',
                      minHeight: '85vh',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Routes />
                  </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                  ©2017 CCBS台球联盟
                </Footer>
              </Layout>
            </Layout>
            {this.state.showName && (
              <div className="full_name">
                {sessionStorage.getItem('club_name')}
              </div>
            )}
          </ConfigProvider>
        )}

        {isRechargeHelpPage && <Routes />}
      </div>
    )
  }
}
export default HomeView



// WEBPACK FOOTER //
// ./src/containers/Home/component/home.js